import { memo, useMemo } from "react";
import { generatePath, Link } from "react-router";

import { PATHS } from "@/routes/paths";

import { Button } from "@/components/ui/button/button";

import { SearchedContents, SearchForm } from "./components";
import { useSearchActions, useSearchContents } from "./hooks";
import { FeatureIslandContainer, FeatureIslandHeader, FeatureIslandMain } from "../../_layouts";
import { useInitialized } from "../model/use-case";

type Props = {
	hotelID: string;
};

export const FAQ = memo(({ hotelID }: Props) => {
	const { queryData } = useInitialized();

	const { searchText, handleChangeSearchText } = useSearchActions();

	// 遷移先の path を生成
	const contactPath = useMemo(
		() => ({
			contact: generatePath(PATHS.HOTEL.CONTACT.TOP, { hotelID }),
			newContact: generatePath(PATHS.HOTEL.CONTACT.NEW, { hotelID }),
		}),
		[hotelID],
	);
	// 検索コンテンツを取得
	const searchContents = useSearchContents();
	const { hostContents, guestContents } = useMemo(
		() => searchContents(searchText, queryData.host, queryData.guest),
		[queryData.guest, queryData.host, searchContents, searchText],
	);

	return (
		<FeatureIslandContainer>
			<FeatureIslandHeader
				title="FAQ"
				rightChildren={
					<div className="flex gap-x-3">
						<Button type="button" size={"lg"} variant="outline">
							<Link to={contactPath.contact} viewTransition>
								過去の問い合わせ一覧
							</Link>
						</Button>
						<Button type="button" size={"lg"}>
							<Link to={contactPath.newContact} viewTransition>
								質問する
							</Link>
						</Button>
					</div>
				}
			/>
			<FeatureIslandMain>
				<div className="grid gap-8">
					<SearchForm searchText={searchText} onChangeSearchText={handleChangeSearchText} />
					<SearchedContents hostContents={hostContents} guestContents={guestContents} />
				</div>
			</FeatureIslandMain>
		</FeatureIslandContainer>
	);
});
